import { render } from "./subordinate.vue?vue&type=template&id=35972782&scoped=true"
import script from "./subordinate.vue?vue&type=script&lang=js"
export * from "./subordinate.vue?vue&type=script&lang=js"

import "./subordinate.vue?vue&type=style&index=0&id=35972782&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35972782"]])

export default __exports__